export default function TechSpecs() {
  return (
    <section id="tech" className="py-24 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-black mb-4 tracking-tight">ENGINEERED TO DOMINATE</h2>
          <p className="text-base md:text-xl text-gray-400 max-w-4xl mx-auto leading-relaxed">User driven design bridges the gap between manual and powerchair's like never before. These chairs retain all the functionality to be 100% manual. With quick release interchangeable wheels and a quick release Powertube this makes for the ultimate of both worlds. Ideal for both rigid and folding frames.</p>
        </div>

        <div className="relative rounded-2xl overflow-hidden">
          <div className="w-full h-[280px] sm:h-[420px] md:h-[600px]">
            <img 
              src="https://public.readdy.ai/ai/img_res/edited_64f9cba1579209002c7d42b9b32c1610_13eae41e.jpg"
              alt="Technology"
              width="1280"
              height="600"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-8 md:p-12 text-center">
            <h3 className="text-2xl md:text-4xl font-black mb-3 md:mb-4">INNOVATION IN MOTION</h3>
            <p className="text-sm md:text-lg text-gray-300 mb-4 md:mb-6 max-w-3xl mx-auto">
              Every component is carefully selected and tested to ensure maximum performance, reliability, and style. We don&apos;t just build chairs—we craft mobility experiences.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}